import { useProjectListFilterOptionsQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import type { Store } from "../Store";

export const useFetchFilterOptions = (store: Store) => {
  useProjectListFilterOptionsQuery({
    onCompleted(data) {
      store.setTableOptions(data);
    },
    ...onError(),
  });
};
